var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrioritize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Prioritize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8---CalendarView",
    transform: "translate(-550.000000, -916.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-8",
    transform: "translate(444.000000, 400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Prioritize2",
    transform: "translate(105.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Caret-Up"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.666667, 4.166667)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3036405,0.198183406 C3.03023577,-0.0660611352 2.57456122,-0.0660611352 2.2829295,0.198183406 L0.205053548,2.20644192 C-0.0683511827,2.47068646 -0.0683511827,2.91109402 0.205053548,3.19295487 C0.478458279,3.45719941 0.93413283,3.45719941 1.22576454,3.19295487 L2.0824327,2.36498864 L2.0824327,10.4861042 C2.0824327,10.8736629 2.41051838,11.17314 2.793285,11.17314 C3.17605162,11.17314 3.5041373,10.8560466 3.5041373,10.4861042 L3.5041373,2.36498864 L4.36080546,3.19295487 C4.50662131,3.33388529 4.68889113,3.4043505 4.87116095,3.4043505 C5.05343077,3.4043505 5.2357006,3.33388529 5.38151645,3.19295487 C5.65492118,2.92871033 5.65492118,2.48830276 5.38151645,2.20644192 L3.3036405,0.198183406 Z",
    id: "Path",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.333333, 4.166667)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 3.793262e-14,
    width: 10,
    height: 1.16666667,
    rx: 0.583333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0,
    y: 3.33333333,
    width: 8.33333333,
    height: 1.16666667,
    rx: 0.583333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 0,
    y: 6.66666667,
    width: 5.83333333,
    height: 1.16666667,
    rx: 0.583333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0,
    y: 10,
    width: 3.33333333,
    height: 1.16666667,
    rx: 0.583333333
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrioritize);
export default __webpack_public_path__ + "static/media/Prioritize.684827088467b4b8d8b10ad1cad4a845.svg";
export { ForwardRef as ReactComponent };